/**
 * On page load
 **/
var $ = jQuery.noConflict();

var windowWidth = $(window).width();

$(document).ready(function () {


    if (windowWidth < 798) {
        setUpMenu();
    }

    toggleSubNav();
    toggleMobNav();

});


function setUpMenu() {
    var $nav = $('#primary-nav');
    var subNavs = $nav.find('.sub-menu');
    var subNavParent = $(subNavs).closest('.menu-item-has-children');
    var sub_menu_toggle = '<span class="sub_menu_toggle"></span>';

    if (!$('.sub_menu_toggle').length) {
        subNavParent.each(function () {
            $(this).append(sub_menu_toggle);
        });
    }
}
function toggleSubNav() {

    $('body').on('click', '.sub_menu_toggle', function () {
        var parent = $(this).parent();
        var subMenu = parent.find('.sub-menu');
        subMenu.toggleClass('active');
    });
}
function toggleMobNav() {
    $('#mobile-link').on('click', function () {
        $(this).toggleClass('active');
        $('#primary-nav').toggleClass('active');

        if ($('#mobile-booking-link').length > 0) {
            $('#mobile-booking-link').toggle();
        }
    });
}

$(window).resize(function () {
    windowWidth = $(window).width();
    if (windowWidth < 798) {
        setUpMenu();
    }
});